import {
  AgeConfirmation,
  ConfirmLoginMail,
  IncompletePersonalData,
  UiModal,
  UserLoginModal,
  UsersUnder16,
} from "libs/raas-ui-react-components/src/components";
import useSession from "hooks/useSession";
import {
  IUserData,
  RaaSSession,
  SessionStorageItems,
  getDeviceKey,
  setStorage,
  setUserDetail,
} from "services/user/user.session.service";
import {
  ConfirmModalLiterals,
  LoginModalLiterals,
  PersonalDataModalLiterals,
  ReactPathNavigation,
  getResumePath,
} from "pages/private/TripSelector/TripSelector.util";
import { apiNames } from "services/api/endpoint.service";
import { postAxios } from "services/api/api.service";
import useToast from "hooks/useToast";
import { getUserData } from "services/user/user-micros.service";
import { CHECKAGE, checkUnder16 } from "services/util/util.service";
import {
  apiUpdateUnder16Age,
  getUsersUnder16Literals,
} from "../Planner/PlannerFlow.service";
import { getPromiseByProvider } from "services/user/user-login-social.service";
import { openMail } from "../RegistroUser/RegisterUser.service";
import { removeItemStorage } from "services/util/sessionStorage.service";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
declare const window: any;
export const LoginModal = (props: any) => {
  // Login modal
  const { setSession, setLogged, setUserConnected } = useSession();
  const { openToast } = useToast();
  const [t] = useTranslation("tripSelector");
  const [tGlobal] = useTranslation("global");
  const literalsConfirmEmail = ConfirmModalLiterals(t);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginToken, setLoginToken] = useState();
  const [email, setEmail] = useState("");
  const [password, setPass] = useState("");
  const [confirmationAge, setConfirmationAge] = useState(false);
  const [isOver16, setIsOver16] = useState(false);
  const [showModalUnder16, setShowModalUnder16] = useState(false as boolean);
  const usersUnder16ModalLiterals = getUsersUnder16Literals(t);
  const [step, setStep] = useState(0);

  const { openMissing, openModal,urlNavigate } = props;
  const navigate = useNavigate();

  useEffect(() => {
    if (openModal === true) {
      setShowLoginModal(true);
    }

    if (openMissing === true) {
      openMissingMandatoryInfoModal();
    }
  }, []);

  const callLoginMicroService = (data: { email: string; password: string }) => {
    setEmail(data?.email);
    setPass(data?.password);
    let loginBody = {
      username: data?.email,
      password: data?.password,
      deviceKey: getDeviceKey(),
    };
    postAxios(apiNames.IDENTITY, false, "/sessions/login", loginBody)
      .then((response: any) => {
        setLoginToken(response?.data?.token);
        if (response.status === 206) {
           
          openToast(
            "success",
            t("literals.sendEmail"),
            t("literals.findYourCodeIn") + t("literals.yourEmail") + data?.email
          );
          setStep(1);
        } else {
          okLogin(response?.data);
        }
      })
      .catch(() => {
        let literal = t("literals.anErrorOccurred");
        openToast("error", t("literals.error"), literal);
      });
  };

  const okLogin = (data: any) => {
    setSession(data);
    setStorage(data);
    setLogged(true);
    getData();
  };
  const getData = () => {
    getUserData(
      (response: any) => {
        const userDataResponse = response?.data;
        // setItemStorage(SessionStorageItems.RAAS_USER);
        setUserDetail(userDataResponse);
        setUserConnected(userDataResponse);
        setShowLoginModal(false);

        checkForMinors(userDataResponse, () => {
          // Se ejecuta el callback si se ha checkeado bien.
          const missingMandatoryInfo = userDataResponse?.missingMandatoryInfo;
          if (missingMandatoryInfo) {
            navigate(urlNavigate);
          }
        });
      },
      () => {
        openToast("error", "Error", t("literals.tryAgainLater"));
      }
    );
  };

  const checkForMinors = (data: any, callback?: Function) => {
    const checkId = checkUnder16(data);
    switch (checkId) {
      case CHECKAGE.askRequired:
        setIsOver16(false);
        setConfirmationAge(true);
        break;
      case CHECKAGE.isUnderAge:
        setIsOver16(false);
        setConfirmationAge(true);
        break;
      case CHECKAGE.mandatoryAgeNeeded:
        setIsOver16(false);
        setConfirmationAge(true);
        break;
      case CHECKAGE.mandatoryAgeNeededNoOver16:
        setIsOver16(false);
        setConfirmationAge(true);
        break;
      default:
        callback && callback();
        break;
    }
  };

  const handleLoginSocial = ({ detail }: CustomEvent) => {
    window.dataLayer?.push({
      event: "select_content",
      screen_name: "welcome",
      screen_class: "onboarding",
      content_name: "social_login",
      content_type: detail,
    });
    getPromiseByProvider(detail);
  };

  const handleReSendEmail = () => {
    openToast(
      "success",
      t("literals.sendEmail"),
      t("literals.findYourCodeIn") + t("literals.yourEmail") + email
    );
    let loginBody = {
      username: email,
      password: password,
      deviceKey: getDeviceKey(),
    };
    postAxios(apiNames.IDENTITY, false, "/sessions/login", loginBody)
      .then((response: any) => {
        setLoginToken(response?.data?.token);
        if (response.status === 206) {
          navigate("/tmb-resume-route");
        } else {
          okLogin(response?.data);
        }
      })
      .catch(() => {
        // TODO literles porne en todos los idiomas esta solo en español
        let literal = t("literals.anErrorOccurred");
        openToast("error", "Error", literal);
      });
  };

  const handleOpenMail = () => {
    openMail(email);
  };

  const openMissingMandatoryInfoModal = () => {
    setStep(2);
    setShowLoginModal(true);
  };

  const hadleVerifyMail = (data: any) => {
    const code = data?.detail;
    let verifyBody = {
      token: loginToken,
      email,
      code,
    };
    postAxios(
      apiNames.IDENTITY,
      false,
      "/sessions/verification-code",
      verifyBody
    )
      .then((response: any) => {
        if (response?.status == 206) {
          setLoginToken(response?.data?.token);
          openToast("error", "Error", t("literals.incorrectCode"));
        } else {
          if (document.body.style?.overflow === "hidden") {
            document.body.style.overflow = "auto";
          }
          okLogin(response?.data);
        }
      })
      .catch((error: any) => {
        if (error?.status === 400) {
          openToast("error", "Error", t("literals.incorrectCode"));
        } else if (error.status === 401) {
          openToast("error", "Error", t("literals.wrongEmailPassword"));
          setStep(0);
        }
      });
  };
  const goToProfile = () => {
    //navigate("/personal-data?goTo=/tmb-resume-route");
    navigate(`/personal-data?goTo=`+`${urlNavigate}`)
  };

  const okModalUnder16 = () => {
    /* window.dataLayer?.push({
          event: "select_content",
          screen_name: 'legal_age_needed_alert',
          screen_class: mappingScreenNameAnalytics(window.location.pathname),
          content_type: 'button',
          content_name: 'add_legal_age',
        });*/
    setShowModalUnder16(false);
    navigate(`/personal-data?goTo=`+`${urlNavigate}`)
  };

  /* AgeConfirmation Modal: soy menor de 16, boton "Entendido" */
  const handleUnderstoodClick = () => {
    setIsOver16(false);
    setConfirmationAge(false);
    apiUpdateUnder16Age(
      true,
      () => {
        setShowLoginModal(false);
        setStep(0);
        logoutClick();
      },
      (err: any) => {
        console.warn("Algo ha ido mal: ", err);
      }
    );
  };

  const logoutClick = () => {
    setLogged(false);
    setSession({} as RaaSSession);
    setUserConnected({} as IUserData);
    removeItemStorage(SessionStorageItems.RAAS_USER);
    removeItemStorage(SessionStorageItems.RAAS_USER_DETAIL);
    setStorage();
  };

  /* AgeConfirmation Modal: confirmo que soy mayor de 16 años */
  const handleCloseModalClick = () => {
    // console.log('handleCloseModalClick');
    /* Cierro todas las modales */
    setIsOver16(false);
    setConfirmationAge(false);
    setShowModalUnder16(false);

    /* Actualizo la variable under16 a false */
    apiUpdateUnder16Age(
      false,
      (userData: any) => {
        /* Vuelvo a comprobar, por si birthDate viene null */
        setShowLoginModal(false);
        checkForMinors(userData);
      },
      (err: any) => {
        console.warn("Algo ha ido mal: ", err);
      }
    );
  };

  const getModalSlot = (currentStep: number) => {
    switch (currentStep) {
      case 0:
        return (
          <UserLoginModal
            literals={JSON.stringify(LoginModalLiterals(t))}
            react-path-navigation={JSON.stringify(ReactPathNavigation)}
            onCloseModal={() => setShowLoginModal(false)}
            onLoginEventClick={(e: any) => callLoginMicroService(e.detail)}
            onNavigateToEventClick={(e: any) =>  navigate(e.detail)}
            onLoginSocialClicked={handleLoginSocial}
          ></UserLoginModal>
        );
      case 1:
        return (
          <ConfirmLoginMail
            literals={JSON.stringify(literalsConfirmEmail)}
            mail={email}
            onResendMail={handleReSendEmail}
            onOpenMail={handleOpenMail}
            onVerifyEmail={hadleVerifyMail}
            onBackPage={() => setStep(0)}
            onCloseModal={() => setShowLoginModal(false)}
          />
        );
      case 2:
        return (
          <IncompletePersonalData
            literals={JSON.stringify(PersonalDataModalLiterals(t))}
            onCancelClickEvent={() => setShowLoginModal(false)}
            onGoToProfileClickEvent={() => goToProfile()}
          />
        );
    }
  };
  return (
    <>
      <UiModal
        open={showLoginModal}
        blockOverlay={true}
        onModalClosed={() => setShowLoginModal(false)}
        notUseShiftLogic={true}
      >
        {getModalSlot(step)}
      </UiModal>
      {/* Control age */}
      <UiModal open={showModalUnder16} blockOverlay={true}>
        <UsersUnder16
          literals={usersUnder16ModalLiterals}
          onConfirmButtonEvent={() => okModalUnder16()}
        />
      </UiModal>
      <UiModal open={confirmationAge} blockOverlay={true}>
        <AgeConfirmation
          literals={{
            title: tGlobal("age-confirmation.title"),
            description: tGlobal("age-confirmation.description"),
            buttonText: tGlobal("age-confirmation.buttonText"),
            confirmationButton: tGlobal("age-confirmation.confirmationButton"),
            secondaryButtonText: tGlobal(
              "age-confirmation.secondaryButtonText"
            ),
          }}
          confirmation={isOver16}
          onUnderstood={handleUnderstoodClick}
          onCloseModal={handleCloseModalClick}
        />
      </UiModal>
    </>
  );
};
